import React from 'react';
import PropTypes from 'prop-types';
import TestimonialsSlider from 'components/TestimonialsSlider';
import { SSection, STitle, SDotSvg, SSubtitle } from './styles';
import { Container, Row, Col } from 'react-bootstrap';
import TrustPilotStarsSVG from 'images/svg/trust_pilot_stars.svg';
import Image from 'components/Image';
import { testimonials } from 'data_jsons/testimonials';

const TestimonialsSection = ({ backgroundColor, className }) => {
  return (
    <SSection backgroundColor={backgroundColor} className={className}>
      <SDotSvg top isVisibleMobile />
      <Container className="mt-5">
        <Row>
          <Col xs={12} className="text-center mb-5">
            <STitle>{"Don't take our word for it"}</STitle>
            <SSubtitle>See what our clients say about us.</SSubtitle>
          </Col>
          <Col xs={12}>
            <TestimonialsSlider testimonials={testimonials} />
          </Col>
        </Row>
        <Row className="text-center" style={{ marginTop: '150px' }}>
          <Col xs={12} className="mb-4">
            <a
              target="_blank"
              href="https://uk.trustpilot.com/review/oasis-living.org"
            >
              <Image
                styles={{ height: '55px', width: '225px' }}
                filename="affiliations/trustpilot-logo"
              />
            </a>
          </Col>
          <Col xs={12} className="mb-4">
            <a
              href="https://uk.trustpilot.com/review/oasis-living.org"
              target="_blank"
            >
              <TrustPilotStarsSVG />
            </a>
          </Col>
          <Col xs={12}>
            <p className="text-white">4.7 Star rating based on 65 reviews</p>
          </Col>
        </Row>
      </Container>
    </SSection>
  );
};

TestimonialsSection.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
};

export default TestimonialsSection;
